<template>
  <div>
    <v-card dark>
      <v-card-text>
        <v-form ref="form" v-model="formValid">
          <v-row dense>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="mixinFlagsList"
                item-key="DESCRICAO"
                class="text-caption"
                :search="search"
                :custom-filter="filterOnTable"
                dense
                :items-per-page="15"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title class="text-h6"
                      >Flags Setados</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-divider inset vertical></v-divider>
                    <v-text-field
                      v-model="search"
                      class="text-caption"
                      label="Filtrar"
                      dense
                    ></v-text-field>
                  </v-toolbar>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { flagsMixin } from '@/mixins/object/flags/FlagsMixin'

import { mapActions } from 'vuex'

export default {
  name: 'FormFlagsSetados',
  mixins: [flagsMixin],
  components: {},
  data: () => ({
    search: undefined,
    formValid: false,
    headers: [
      { text: 'Descrição', value: 'DESCRICAO', width: 500 },
      { text: 'Parâmetro', value: 'PARAMETRO' },
    ],
    form: {},
  }),
  methods: {
    filterOnTable(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value
          .toString()
          .toLocaleUpperCase()
          .indexOf(search.toLocaleUpperCase()) !== -1
      )
    },
    ...mapActions('dialogModule', [
      'setShowLoadingDialog',
      'setLoadingDialogMessage',
    ]),
  },
}
</script>

<style scoped>
.customClass >>> label {
  font-size: 0.8em;
}
</style>
